import { Utils } from "@/utilities/Utils";
import { mapData } from '@/utilities/DataMapping';
import { FormTagsPlugin } from 'bootstrap-vue';
import { integer } from "vuelidate/lib/validators";


export interface IBookingSearchResult {

    additionalComments: string;
    contractor: string;
    contractorID: number;
    created: Date;
    createdByUserID: number;
    description: string;
    firstStay: Date;
    foodAllowance: number;
    guid: string;
    id: number;
    lastStay: Date;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    latestArrivalDefault: Date;
    numberOfGuests: number;
    parkingRequirements: string;
    scanReportVisible: boolean;
    statusDescription: string;
    statusID: number;
    totalCost: number;
    totalDays: number;
    totalNights: number;
    worksPostCode: string;
    blobColour: string;
    bookingSummaryVisible: boolean;
    confirmDisabled: boolean;
    hasPreferredHotel: boolean;

}

export class BookingSearchResult implements IBookingSearchResult {

    constructor(data?: IBookingSearchResult) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingSearchResult) {
        mapData(data, {
            root: () => this
        })
    }

    additionalComments: string = "";
    contractor: string = "";
    contractorID: number = 0;
    created: Date = new Date(Utils.emptyDateValue);
    createdBy: string = "";
    createdByUserID: number = 0;
    description: string = "";
    firstStay: Date = new Date();
    foodAllowance: number = 0;
    guid: string = Utils.emptyGuidValue;
    id: number = 0;
    lastStay: Date = new Date();
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedBy: string = "";
    lastUpdatedByUserID: number = 0;
    latestArrivalDefault: Date = new Date();
    numberOfGuests: number = 0;
    parkingRequirements: string = "";
    scanReportVisible: boolean = false;
    statusDescription: string = "";
    statusID: number = 0;
    totalCost: number = 0;
    totalDays: number = 0;
    totalNights: number = 0;
    worksPostCode: string = "";
    blobColour: string = "";
    bookingSummaryVisible: boolean = false;
    confirmDisabled: boolean = false;
    hasPreferredHotel: boolean = false;


    //get actionColour() {
    //    let retVal = "";
    //    const x = new Date();
    //    const today = x.getTime();
    //    const firstStay = this.firstStay.getTime();
    //    const lastStay = this.lastStay.getTime();

    //    today > lastStay ? retVal = "green" :
    //        this.statusID == 1 ? retVal = "white" :
    //            this.statusID == 2 ? retVal = "white" :
    //                this.statusID == 3 ? retVal = "white" :
    //                    this.statusID == 4 ? retVal = "red" :
    //                        this.statusID == 5 ? retVal = "green" :
    //                            this.statusID == 6 ? retVal = "orange" :
    //                                retVal = "";
    //    return retVal;
    //}

    //get actionIcon() {
    //    let retVal = "";
    //    const x = new Date();
    //    const today = x.getTime();
    //    const firstStay = this.firstStay.getTime();
    //    const lastStay = this.lastStay.getTime();

    //    today > lastStay ? retVal = "fas fa-history" :
    //        this.statusID == 1 ? retVal = "" :
    //            this.statusID == 2 ? retVal = "" :
    //                this.statusID == 3 ? retVal = "" :
    //                    this.statusID == 4 ? retVal = "fas fa-exclamation-square" :
    //                        this.statusID == 5 && (today > firstStay && today < lastStay) ? retVal = "fas fa-digging" :
    //                            this.statusID == 5 && (today < firstStay) ? retVal = "fas fa-traffic-cone" :
    //                                retVal = "";
    //    return retVal;
    //}


    //get shouldHaveNotification() {
    //    let retVal;
    //    //needstogohere
    //    this.statusID == 3 ? retVal = true :
    //        this.statusID == 4 ? retVal = true :
    //            this.statusID == 5 ? retVal = true :
    //                retVal = false;
    //    return retVal;
    //}

    ///*        today >= lastStay ? retVal = "Last stay in the past" :*/
//            this.statusID == 1 ? retVal = "Incomplete" :
//                this.statusID === 2 ? retVal = "Requested" :
//                    this.statusID === 3 ? retVal = "Processing" :
//                        this.statusID === 4 ? retVal = "Booking ready for confirmation" :
//                            this.statusID === 5 && (today > firstStay && today < lastStay) ? retVal = "In progress" :
//                                this.statusID === 5 && (today < firstStay) ? retVal = "Pending" :
//                                    this.statusID === 6 ? retVal = "Completed" :
//                                        retVal = "a";


    get notificationMessage() {
        const today = new Date();
        let retVal = "";
        if (this.statusID === 1) return retVal = "Incomplete";
        if (this.statusID === 2) return retVal = "Requested";
        if (this.statusID === 3) return retVal = "Being Processed";
        if (this.statusID === 4) return retVal = "Awaiting Confirmation";
        if (this.statusID === 5 && (this.firstStay <= today && this.lastStay >= today)) return retVal = "In Progress";
        if (this.statusID === 5) return retVal = "Booked";
        if (this.statusID === 6) return retVal = "Completed";
        if (this.statusID === 7) return retVal = "Cancelled";
        if (this.statusID === 8) return retVal = "Confirmed";
        return retVal;
    }
}